// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // Prod Env Urls

  // apiUrl: "https://adminapi.imtransporter.com/",

  // apiUrl1: "https://adminapi.imtransporter.com/",

  // filePath: "https://adminapi.imtransporter.com/fileupload",

  // socketUrl: "https://socket.imtransporter.com/admin",

  // Dev Env Urls

  socketUrl:"https://testsocket.imtransporter.com/admin",

  apiUrl : "https://testadminapi.imtransporter.com/",

  apiUrl1 : 'https://testadminapi.imtransporter.com/',

  filePath : "https://testadminapi.imtransporter.com/fileupload",

  //local env urls

  // socketUrl: "http://localhost:3000/admin",

  // apiUrl: "http://localhost:5000/",

  // apiUrl1: "http://localhost:5000/",

  // filePath: "http://localhost:5000/fileupload",

  labourCost: 500,
  couponCost: 200,


 firebase : {
  apiKey: "AIzaSyBrZIRCXD8I8eMOP_0iOaTJUAa6yBicWyI",
  authDomain: "imtransporter-20385.firebaseapp.com",
  projectId: "imtransporter-20385",
  storageBucket: "imtransporter-20385.firebasestorage.app",
  messagingSenderId: "1026468682344",
  appId: "1:1026468682344:web:3c05dc3e58a100a05ef9dd",
  measurementId: "G-3W6315NE83",
  vapidKey:"BC-MvkOqd5uAECG9sp4NDqQppNzaTtvIhUSY-WaP2PPUvnou-C3nwHbgzckHphostIsHLZyVIBOoVdA66k4mXiY"
},

};

